import { FareCode } from "@silversea-ssc/web-fares";
import {
  isDevBuild,
  isEnvFeatureEnabled,
  useClientSideFeatureFlag
} from "../../utils/feature-flags";

export const unbundlingFares: FareCode[] = ["Plus", "Basic", "LastMinute"];

export const showOnlyUnbundlingFare =
  (enabled: boolean) =>
  <T extends { fare: FareCode }>(fare: T) => {
    if (!enabled) return true;

    return unbundlingFares.includes(fare.fare);
  };

export const showOnlyUnbindlingFareCode = (enabled: boolean) => {
  return (fareCode: FareCode) => {
    if (!enabled) return true;

    return unbundlingFares.includes(fareCode);
  };
};

const UNBUNDLING_CUTOFF_DATE = new Date("2025-09-11T04:00:00.000Z");

export const isAfterUnbundlingCatoffDate = () => {
  return new Date() >= UNBUNDLING_CUTOFF_DATE;
};

export const isUnbundlingStaticallyEnabled = () => {
  return (
    isAfterUnbundlingCatoffDate() ||
    isEnvFeatureEnabled(process.env.GATSBY_UNBUNDLING_FARES) ||
    isDevBuild()
  );
};

export const useUnbundlingFeatureFlagEnabled = () => {
  const enabled = useClientSideFeatureFlag("unbundling");
  return enabled || isAfterUnbundlingCatoffDate();
};
